<template>
<div id="rclife_widget_center_column" style="min-height: 450px;">
    <div class="section-header" id="mc_rclife">
        <h2>
            <a>RealClearLife By InsideHook</a>
            <span style="float:right;">
                <a href="https://www.insidehook.com/realclearlife-by-insidehook" 
                    style="font-size:0.6em; color:#d30015; font-family:'Roboto',sans-serif;">View More &#8594;</a>
            </span>
        </h2>

        <template v-for="(item, index) in data.rc_life_first" >
            <div v-if="(index + 1) % 3 == 1 && (index + 1) != 1" :key="`${item.id}-clear`" class="clear"></div>
            <div :key="`${item.id}-item`" class="item">
			    <div class="image">
			        <a :href="item.link" :onclick="`return ClickTracking.record_click(event, ${item.id}, '${encodeURIComponent(item.title)}', 'center-column-widget', 'RCLife_RCP_Homepage_MC', '1', '${(index + 1)}', 'RCLife+HP+Widgets');`" >
                        <img :alt="item.title"  :src="item.image" />
                    </a>
                </div>
			    <a :href="item.link" :onclick="`return ClickTracking.record_click(event, ${item.id}, '${encodeURIComponent(item.title)}', 'center-column-widget', 'RCLife_RCP_Homepage_MC', '1', '${(index + 1)}', 'RCLife+HP+Widgets');`" 
                    v-html="item.title" ></a>
			</div>
        </template>

    </div>
    <div style="clear:both; height:0;"></div>
</div>
</template>

<script>
export default {
    name: 'center-column-widget',
    data() {
        return {
            data: [],
        };
    },
    created(){
        this.initWidget();
    },
    methods: {
        
        initWidget(){

            $.ajax({
                crossDomain: true,
                url: 'https://www.realclearpolitics.com/include/rclife_first.jsonp',
                dataType: 'jsonp',
                jsonp: 'callback',
                jsonpCallback: 'rclife_first_callback',
                success : res => {
                    // console.log("rclife_first_callback", res);
                    this.$set(this, 'data', res);
                }
            });
        },

    },
}
</script>

<style lang="scss" >
#mc_rclife div.item {float:left; width:31%; padding:0 1%;}
#mc_rclife div.item div.image{height:100px; overflow:hidden; margin-bottom:10px;}
#mc_rclife div.item div.image img {width:100%;}
@media only screen and ( max-width : 767px ){ #mc_rclife div.item div.image {height:50px; margin-bottom:5px; } } 
</style>